import { styled } from '@mui/material/styles';

import { NAVBAR_HEIGHT } from 'constants/general';

export const Root = styled('div')(({ theme }) => ({
  height: `${NAVBAR_HEIGHT}px`,
  width: '100%',
  backgroundColor: theme.palette.primary.dark,
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const TabsWrapper = styled('div')(() => ({
  height: `${NAVBAR_HEIGHT}px`,
  position: 'absolute',
  width: '100%',
  justifyContent: 'center',
  display: 'flex',

  '& div:first-of-type': {
    zIndex: 1002,
  },
}));
